// extracted by mini-css-extract-plugin
export default {"matrix":"index_matrix__Fq7eI"};